/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Us_Ai_SummaryInputs */

const en_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A designed, rules-based, equal-weight model portfolio tracking companies at the forefront of artificial intelligence, including Nvidia, Microsoft, Alphabet, Meta, Amazon, SpaceX, Tesla, and Sandisk Corp. (via tokenized stock).`)
};

const de_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleich gewichtetes Engagement in US-Unternehmen, die die Innovation im Bereich künstliche Intelligenz anführen, darunter NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla und SanDisk Corp.`)
};

const pt_br2_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposição com pesos iguais às empresas dos EUA que lideram a inovação em inteligência artificial, incluindo NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla e SanDisk Corp.`)
};

const tr_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla ve SanDisk Corp dahil olmak üzere yapay zekâ alanındaki yeniliklere öncülük eden ABD merkezli şirketlere eşit ağırlıklı yatırım.`)
};

const zh_cn2_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等权重投资于引领人工智能创新的美国公司，包括英伟达、微软、谷歌、Meta、亚马逊、SpaceX、特斯拉和 SanDisk Corp。`)
};

const zh_hk2_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等權重投資於引領人工智能創新的美國公司，包括 NVIDIA、Microsoft、Google、Meta、Amazon、SpaceX、Tesla 及 SanDisk Corp。`)
};

const ko_kr2_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인공지능 혁신을 이끄는 미국 기업에 동일 비중으로 투자합니다. NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla, SanDisk Corp 등이 포함됩니다.`)
};

const ru_ru2_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Равновзвешенные вложения в американские компании, ведущие инновации в сфере искусственного интеллекта, включая NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla и SanDisk Corp.`)
};

const es_419_strategy_partner_us_ai_summary = /** @type {(inputs: Strategy_Partner_Us_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exposición de igual ponderación a las empresas de EE. UU. que lideran la innovación en inteligencia artificial, incluidas NVIDIA, Microsoft, Google, Meta, Amazon, SpaceX, Tesla y SanDisk Corp.`)
};

/**
* | output |
* | --- |
* | "A designed, rules-based, equal-weight model portfolio tracking companies at the forefront of artificial intelligence, including Nvidia, Microsoft, Alphabet, ..." |
*
* @param {Strategy_Partner_Us_Ai_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_us_ai_summary = /** @type {((inputs?: Strategy_Partner_Us_Ai_SummaryInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Us_Ai_SummaryInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_us_ai_summary(inputs)
	if (locale === "de") return de_strategy_partner_us_ai_summary(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_us_ai_summary(inputs)
	if (locale === "tr") return tr_strategy_partner_us_ai_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_us_ai_summary(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_us_ai_summary(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_us_ai_summary(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_us_ai_summary(inputs)
	return es_419_strategy_partner_us_ai_summary(inputs)
});